import { HttpInterceptorFn, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from './loading.service';

export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Check if request should skip loading indicator (via context)
  const skipLoading = req.context.get(SKIP_LOADING);

  if (!skipLoading) {
    loadingService.incrementRequests();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipLoading) {
        loadingService.decrementRequests();
      }
    }),
  );
};
